import { ClientFormState } from '../../types/client/client.def';
import { isValid } from './error/isValid';

export const isFormValid = (
  client: ClientFormState,
  isPublicShop: boolean
): boolean => {
  if (isPublicShop) return client.isValid && !!client?.values?.relaisid;
  return client.isValid;
};

export const isUpdateFormValid = (client: ClientFormState) => {
  if (!client.errors) return true;
  return isValid(client.errors);
};
